import React, { useState } from 'react';
import Icons from '@techsoftware/happay-widgets/FontIcon';
import Popup from '@techsoftware/happay-widgets/Popup';
import Grid from '@techsoftware/happay-widgets/Grid';
import { onKeyPress } from '@techsoftware/happay-widgets/CommonFunction/commonFunction';
import { currencyFormatter } from '../../helpers/genericFormator';

export default function BalanceSummaryPopup(props) {
  const [open, setOpen] = useState(false);
  const {
    id,
    available = 0,
    currency = 'INR',
    schedule = 0,
    className = '',
    hideInfo,
  } = props;

  const handleClose = event => {
    const target = event?.target || event?.srcElement;
    const className = event.target.parentElement.className;
    const targetId = target?.id;
    if (
      !className?.includes('currency') &&
      !targetId?.includes(`${id}-arrow`)
    ) {
      setOpen(false);
    }
  };

  const handleOpen = event => {
    event.stopPropagation();
    setOpen(!open);
  };

  const remainingBalance = +available - +schedule;

  return (
    <Popup
      id={`${id}-popup`}
      open={open}
      pointerPlacement="top-right"
      popupStyle={{ top: 30, right: -10 }}
      onClose={handleClose}
      variant="scroll"
      parentElement={
        <div
          id={id}
          tabIndex={0}
          onKeyDown={event => onKeyPress(event, () => handleOpen(event))}
          onClick={handleOpen}
          className={`section-heading dark focus-visible font-18 letter-spacing-30 pointer user-select-none ${className}`}
        >
          {currencyFormatter(available, currency)}
          <Icons
            id="bar-wallet-limit-arrow"
            type="dropdown"
            className={`pointer ease-in rotate-${open ? '180' : '0'}`}
          />
        </div>
      }
    >
      <div
        className="padding-16 font-14 fw-400 body width-265"
      >
        <Grid container justify="space-between" className="d-flex">
          Schedule Payments
          <span className="fw-500">
            {currencyFormatter(schedule, currency)}
          </span>
        </Grid>
        <Grid container justify="space-between" className="d-flex margin-t-6">
          Remaining Credit
          <span
            className={`fw-500 ${
              remainingBalance <= 0 ? 'alert-red-color' : ''
            } `}
          >
            {currencyFormatter(remainingBalance, currency)}
          </span>
        </Grid>
        {!hideInfo && remainingBalance < 0 && (
          <div
            className="padding-12 font-12 body border-radius-4 margin-t-6 light-red-bg"
          >
            Please ensure that you have a sufficient balance at all times to
            avoid payment failure.
          </div>
        )}
      </div>
    </Popup>
  );
}
